module.exports = __webpack_public_path__ + "static/media/Beeldsluiter_Logo_2020_EPS.4ada3133.svg";